import upperFirst from 'lodash/upperFirst'
import { compose, mapProps, lifecycle, withStateHandlers } from 'recompose'

const status = {
  INITIAL: 'initial',
  REQUEST: 'request',
  SUCCESS: 'success',
  FAILURE: 'failure',
}

const setStatus = (status, getMessage) => (
  (_, props) => (
    (error = null) => ({
      actionState: {
        status,
        message: getMessage(props),
        error,
      }
    })
  )
)

const withStatus = ({
  actionName = 'action',
  statusName = 'actionStatus',
  getAction = () => () => {},
  getOnInitial = () => () => {},
  getOnRequest = () => () => {},
  getOnActionSuccess = () => () => {},
  getOnSuccess = () => () => {},
  getOnFailure = () => () => {},
  getInitialMessage = () => '',
  getRequestMessage = () => '',
  getSuccessMessage = () => '',
  getFailureMessage = () => '',
}) => (
  compose(
    withStateHandlers({
      actionState: {
        status: status.INITIAL,
        error: null,
        message: null,
      },
    }, {
      setInitial: setStatus(status.INITIAL, getInitialMessage),
      setRequest: setStatus(status.REQUEST, getRequestMessage),
      setSuccess: setStatus(status.SUCCESS, getSuccessMessage),
      setFailure: setStatus(status.FAILURE, getFailureMessage),
    }),
    mapProps(({
      actionState,
      setInitial,
      setRequest,
      setSuccess,
      setFailure,
      ...props,
    }) => {
      const action = getAction(props)
      const onInitial = getOnInitial(props)
      const onRequest = getOnRequest(props)
      const onSuccess = getOnSuccess(props)
      const onFailure = getOnFailure(props)
      const onActionSuccess = getOnActionSuccess(props)
      return {
        [`reset${upperFirst(statusName)}`]: () => {
          setInitial()
          return onInitial()
        },
        [actionName]: (...args) => {
          setRequest()
          onRequest()
          return action(...args).then((...other) => {
            onActionSuccess(...args)
            onSuccess(...other)
            return setSuccess()
          })
            .catch((error) => {
              console.log('error', error)
              onFailure(error)
              setFailure(error)
            })
        },
        [statusName]: {
          isInitial: actionState.status === status.INITIAL,
          isRequest: actionState.status === status.REQUEST,
          isSuccess: actionState.status === status.SUCCESS,
          isFailure: actionState.status === status.FAILURE,
          errorMessage: actionState.error ? actionState.error.message : '',
          message: actionState.message || '',
        },
        ...props,
      }
    })
  )
)

export default withStatus



// WEBPACK FOOTER //
// ./src/hocs/bases/withStatus.js